<template>
    <div class="share">
        <div class="header-video"
             v-if="url">
            <Video :id="'live-video-' + lesson.id"
                   :url="lesson.url"
                   :poster="lesson.poster"
                   :width="width"
                   :height="height"
                   :autoplay="true">
            </Video>
        </div>
    </div>
</template>

<script>
import jsonp from 'jsonp';
import Video from "../video"

export default {
    name: "SmallVideo",
    props:{
        lesson: Object
    },
    data(){
        return {
            pid: this.$route.params.id,
            url: null,
            poster: null,
            width: "100%",
            height: "100%",
        }
    },
    components: {
        Video
    },
    methods: {
        getSmallVideo () {
            this.axios.get(`/data/${this.$route.params.sortid}.json?t=${Math.round(new Date().getTime()/100000)}`).then((res) => {
                this.isLoading = false;
                res.data.courselist.forEach(item => {
                    if(item.articleid == this.$route.params.id){
                        this.url = item.playurl;
                        this.poster = item.img;  
                    }
                })
            });
        },
        errorCallback(){
            window.location.reload();
        }
    },
    mounted(){
        this.getSmallVideo();
    },
}
</script>

<style>
.share {
    background: #000;
    width: 100%;
    height: 100%;
    position: relative;
}
.header-video,
.video-wrap,
.header-video div {
    height: 100%;
    width: 100%;
}
.vcp-poster img{
    width: 100%;
}
.vcp-player {
    position: relative;
    z-index: 0;
    font-family: Tahoma, "\5FAE\8F6F\96C5\9ED1", \u5b8b\u4f53, Verdana, Arial,
        sans-serif;
    background-color: black;
}
</style>
